/*
 * @Author: your name
 * @Date: 2019-10-31 15:01:26
 * @LastEditTime: 2020-09-01 09:56:05
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/directive/v-background-color.js
 */
/**
 * 定义vue指令
 */
export default {
  install(Vue) {
    //使用v-backgroundColor ，设置页面背景颜色
    Vue.directive('backgroundColor', {
      inserted (el,binding) {
        console.log('35555555555')
        document.documentElement.style.backgroundColor = binding.value
      },
      unbind (el,binding) {
        document.documentElement.style.backgroundColor = ''
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/v-background-color.js